import React from "react";

const ProductListSkeleton = ({ count = 6 }) => {
  return (
    <div className="animate-pulse">
      <table className="w-full">
        <tbody>
          {Array(count)
            .fill("")
            .map((_, index) => (
              <tr key={index} className="border-b border-gray-100">
                {[...Array(8)].map((_, i) => (
                  <td key={i} className="px-4 py-4">
                    <div className="h-4 bg-gray-200 rounded w-full"></div>
                  </td>
                ))}
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default ProductListSkeleton;
